<template>
    <div class="wrapper">
        <v-head></v-head>
        <v-sidebar></v-sidebar>
        <div class="content-box" :class="{'content-collapse':collapse}">
            <!-- <v-tags></v-tags> -->
            <div class="content">
                <transition name="move" mode="out-in">
                    <keep-alive :include="tagsList">
                        <router-view></router-view>
                    </keep-alive>
                </transition>
                <el-backtop target=".content"></el-backtop>
                <!-- <div class="menuBox">
                    <el-collapse-transition>
                        <div v-show="showMenu">
                            <div class="menuList iconfont icon-zixun" title="人工咨询"></div>
                            <div class="menuList iconfont icon-gongdan" title="客服工单"></div>
                            <div class="menuList iconfont icon-bangzhu" title="帮助文档"></div>
                        </div>
                    </el-collapse-transition>
                    <div
                        @click="showMenu = !showMenu"
                        class="openMenu menuList iconfont icon-caidan"
                    ></div>
                </div> -->
            </div>
        </div>
    </div>
</template>

<script>
import vHead from './Header.vue';
import vSidebar from './Sidebar.vue';
import vTags from './Tags.vue';
import bus from './bus';
export default {
    data() {
        return {
            tagsList: [],
            collapse: false,
            showMenu: false
        };
    },
    components: {
        vHead,
        vSidebar,
        vTags
    },
    created() {
        bus.$on('collapse-content', msg => {
            this.collapse = msg;
        });

        // 只有在标签页列表里的页面才使用keep-alive，即关闭标签之后就不保存到内存中了。
        bus.$on('tags', msg => {
            let arr = [];
            for (let i = 0, len = msg.length; i < len; i++) {
                msg[i].name && arr.push(msg[i].name);
            }
            this.tagsList = arr;
        });
    }
};
</script>


<style lang="less" scoped>
.menuBox {
    position: fixed;
    right: 40px;
    bottom: 80px;
    z-index: 99;
}

.menuList {
    font-size: 0.4rem;
    border: 1px solid #409eff;
    border-radius: 50%;
    width: 40px;
    height: 40px;
    display: flex;
    align-items: center;
    color: #333;
    justify-content: center;
    background-color: #fff;
    transition: all 0.5s;
    margin: 5px 0;
}
.openMenu {
    background-color: #409eff;
    color: #fff;
}
.menuList:hover {
    color: #fff;
    background-color: #409eff;
    transform: rotate(360deg);
}
</style>